import React, { useState } from 'react';
import { Container, Row, Col, Card, CardBody, Label, Form, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";
import lmsLogo from '../assets/images/lmsLogo.png';
import { createPasswordResetToken, forgotPassword } from '../helper/student_helper'; // <-- call your backend API
import Loader from '../component/Loader/Loader';
import loginBg from '../assets/images/LoginBg.jpg';

const ResetPassword = () => {
    const [loader, setLoader] = useState(false);
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [email, setEmail] = useState("");

    const handleSubmit = async () => {
        try {
            if (!email) {
                setSpanDisplay("block");
            } else {
                setLoader(true);

                const data = await forgotPassword(email);
                if (data?.success) {
                    toast.success(data?.message || "Password reset link sent to your email.");
                    setEmail(""); // clear field
                } else {
                    toast.error(data?.message || "Failed to send reset link.");
                }
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message);
        } finally {
            setLoader(false);
        }
    }

    return (
        <>
            {loader && <Loader />}
            <React.Fragment>
                <div
                    style={{
                        backgroundImage: `url(${loginBg})`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <Container>
                        <Row className="justify-content-center" style={{ width: "90%", margin: "auto" }}>
                            <Col md={8} lg={6} xl={5}>
                                <Card className="overflow-hidden" style={{ boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", border: "none" }}>
                                    <CardBody className="pt-0">

                                        <h3 className="text-center mt-5 mb-2">
                                            <Link to="/" className="d-block auth-logo">
                                                <img src={lmsLogo} alt="logo" height="80" className="auth-logo-dark" />
                                            </Link>
                                        </h3>

                                        <div className="p-3">
                                            <h5 className="text-muted font-size-14 mb-1 text-center">Reset Password</h5>
                                            <p className="text-muted text-center">Enter your registered email to reset password.</p>

                                            <Form
                                                className="form-horizontal mt-4"
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    handleSubmit();
                                                    return false;
                                                }}
                                            >
                                                <div className="mb-3">
                                                    <Label htmlFor="email">Email</Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter registered email"
                                                        type="email"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                    {!email && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                                </div>

                                                <Row className="mb-3 mt-4">
                                                    <div className="col-12 text-end">
                                                        <button
                                                            className={`btn w-md waves-effect waves-light ${loader ? 'btn-secondary' : 'btn-primary'}`}
                                                            type="submit"
                                                            disabled={loader}
                                                        >
                                                            Reset Password
                                                        </button>
                                                    </div>
                                                </Row>
                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>

                                <div className="mt-5 text-center">
                                    © {new Date().getFullYear()} SS <span className="d-none d-sm-inline-block"> - Created By Amass Skill Ventures</span>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        </>
    );
}

export default ResetPassword;
